import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="prefix__Group_2382"
      width={27.773}
      height={27.772}
      viewBox="0 0 27.773 27.772"
      {...props}
    >
      <defs>
        <style>{`.prefix__cls-1{fill:${props.fill}}`}</style>
      </defs>
      <path
        id="prefix__Path_1305"
        d="M892.365 2692.1a40.8 40.8 0 01-.056 4.322c-.047.428-.724.826-1.174 1.153-.179.13-.526.031-.8.031h-21.392c-1.841 0-2.011-.177-2.012-2.012v-15.574c0-1.691.213-1.92 1.84-1.921q10.9-.009 21.8 0c1.549 0 1.781.25 1.794 1.829.01 1.171 0 2.343 0 3.736h-4.737c-2.206.008-3.049.831-3.073 3-.01.9-.022 1.806 0 2.708a2.5 2.5 0 002.7 2.718c1.659.039 3.316.01 5.11.01z"
        className="prefix__cls-1"
        transform="translate(-866.932 -2669.866)"
      />
      <path
        id="prefix__Path_1306"
        d="M941.271 2709.149c-.993 0-1.985-.011-2.978 0-.881.011-1.373-.383-1.366-1.286.042-5.07-.7-4.538 4.08-4.555 1.038 0 2.076.02 3.113-.007 1.062-.027 1.605.439 1.605 1.521 0 5.225.447 4.232-4.454 4.327zm-2.012-1.327l.628-.008c.355-.528 1.042-1.1.976-1.572-.073-.515-.841-.93-1.305-1.389-.451.467-1.2.9-1.265 1.413-.062.467.615 1.034.967 1.556z"
        className="prefix__cls-1"
        transform="translate(-917.963 -2688.25)"
      />
      <path
        id="prefix__Path_1307"
        d="M893.786 2651l-12.611 2.67-.086-.146c.287-.188.566-.391.863-.563q4.1-2.369 8.207-4.728c1.422-.817 1.764-.728 2.578.663q.478.817.94 1.645a2.564 2.564 0 01.109.459z"
        className="prefix__cls-1"
        transform="translate(-877.256 -2647.708)"
      />
      <path
        id="prefix__Path_1308"
        d="M891.548 2665.515c4.028-.848 8.055-1.7 12.086-2.538a1.174 1.174 0 011.515.965c.131.518.231 1.043.374 1.7H891.6z"
        className="prefix__cls-1"
        transform="translate(-884.883 -2658.814)"
      />
    </svg>
  );
}

export default SvgComponent;
